var _style, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChainx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{opacity:0.25;}.b{opacity:0.75;}.c{opacity:0.5;}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-239 -305)translate(239 305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.8 15.5C49.5 15.2 48.8 15.2 48.5 15.5L40.9 23.1C40.5 23.5 40.5 24.1 40.9 24.5L59.8 43.3C64.4 47.9 64.5 55.6 59.8 60.1 55.3 64.5 48 64.5 43.5 60L16 32.5C11.5 28 11.5 20.7 15.9 16.2 20.4 11.5 28.1 11.6 32.7 16.2L35.4 19C35.8 19.3 36.4 19.3 36.8 19L44.4 11.4C44.7 11 44.7 10.4 44.4 10L41.4 7.1C31.9-2.4 16.6-2.4 7.1 7.1 -2.4 16.6-2.4 32 7.1 41.4L34.6 68.9C44 78.4 59.4 78.4 68.9 68.9 78.4 59.4 78.4 44.1 68.9 34.6L49.8 15.5Z",
    className: "a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.9 7.1C103.4-2.4 88.1-2.4 78.6 7.1L60 25.7 68.9 34.6C68.9 34.6 68.9 34.6 68.9 34.6L87.5 16C92 11.5 99.4 11.5 104 16 108.5 20.6 108.5 28 104 32.5L101 35.4C100.7 35.8 100.7 36.4 101 36.8L108.6 44.4C109 44.7 109.6 44.7 110 44.4L112.9 41.4C122.4 32 122.4 16.6 112.9 7.1",
    className: "b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9 40.9C96.5 40.6 95.9 40.6 95.6 40.9L76.5 60C75.7 60.8 74.7 61.5 73.7 62.1 69.3 64.4 63.7 63.7 60 60 60 60 60 59.9 60 59.9 55.5 55.4 55.5 48.1 60 43.5L51.1 34.6C43.7 42 42.1 53.1 46.3 62.1 47.5 64.5 49.1 66.9 51.1 68.9 53.7 71.5 56.8 73.4 60 74.6 62.7 75.5 65.5 76 68.3 76 74.5 76 80.7 73.6 85.4 68.9L104.5 49.9C104.9 49.5 104.9 48.9 104.5 48.5L96.9 40.9Z",
    className: "b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.9 78.6L94.3 60 85.4 68.9 104 87.5C108.5 92 108.5 99.3 104.1 103.9 99.6 108.6 91.9 108.4 87.3 103.8L84.6 101.1C84.2 100.7 83.6 100.7 83.2 101.1L75.6 108.6C75.3 109 75.3 109.6 75.6 110L78.3 112.6C87.8 122.1 103.6 122.4 113 112.8 117.7 108.1 120 101.9 120 95.8 120 89.6 117.6 83.3 112.9 78.6",
    className: "a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1 97C79.5 96.6 79.5 96 79.1 95.6L60 76.5C59.2 75.7 58.5 74.7 58 73.7 55.7 69.3 56.4 63.8 60 60.1L60.1 60C64.6 55.5 71.9 55.5 76.5 60L85.4 51.1C78 43.7 66.9 42.1 58 46.3 55.5 47.5 53.2 49.1 51.1 51.1 48.5 53.7 46.6 56.8 45.5 60 44.5 62.7 44 65.5 44 68.3 44 74.5 46.4 80.7 51.1 85.5L70.2 104.5C70.5 104.9 71.2 104.9 71.5 104.5L79.1 97Z",
    className: "a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6 60.1C74.3 59.4 74 58.6 73.7 57.9 72.5 55.5 70.9 53.1 68.9 51.1 66.8 49.1 64.5 47.5 62.1 46.3 61.4 46 60.7 45.7 60 45.4 51.4 42.3 41.5 44.2 34.6 51.1L43.5 60C44.4 59.1 45.3 58.5 46.3 57.9 50.7 55.6 56.3 56.3 60 60L60 60.1C63.7 63.8 64.3 69.4 62 73.8 61.5 74.7 60.8 75.6 60 76.5L68.9 85.4C75.7 78.5 77.6 68.6 74.6 60.1",
    className: "c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4 79.1L34.6 68.9 25.7 60 15.5 70.2C15.1 70.5 15.1 71.2 15.5 71.5L23.1 79.1C23.4 79.5 24 79.5 24.4 79.1",
    className: "c"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 75)"
  }, /*#__PURE__*/React.createElement("mask", {
    fill: "white"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0.4 60 0.4 60 45 0 45"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.5 29C28 33.5 20.6 33.5 16 29 11.5 24.4 11.5 17 16 12.5L18.9 9.6C19.3 9.2 19.3 8.6 18.9 8.2L11.4 0.7C11 0.3 10.4 0.3 10 0.7L7.1 3.6C-2.4 13-2.4 28.4 7.1 37.9 11.8 42.6 18.1 45 24.3 45 30.5 45 36.7 42.6 41.4 37.9L60 19.3 51.1 10.4 32.5 29Z",
    mask: "url(#mask-2)",
    className: "c"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChainx);
export default __webpack_public_path__ + "static/media/chainx.237572a859f91d89eefe2e7bc09e02a7.svg";
export { ForwardRef as ReactComponent };